<template id="recherche">
    <div class="recherche-container">
        <div class="flex-container">
            <div class="form-group input-group tx-solr-search-form" id="tx-solr-search-form-pi-results">
                <label class="label-invisible" for="recherche_par_mots_cles">Mots clés</label>
                <aside class="motscles-tooltips tooltips_container"><button aria-controls="Infobulle_filtre" aria-label="Afficher information supplémentaire" class="button-info"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve"><desc>Icône pour afficher de l'information supplémentaire</desc> <path d="M8,16c4.4,0,8-3.6,8-8s-3.6-8-8-8S0,3.6,0,8S3.6,16,8,16z M8.9,6.6l-1,4.7c-0.1,0.3,0,0.5,0.3,0.5
									c0.2,0,0.5-0.1,0.7-0.2L8.8,12c-0.3,0.3-0.9,0.6-1.5,0.6c-0.7,0-1-0.4-0.8-1.3l0.7-3.5c0.1-0.3,0-0.4-0.3-0.5L6.6,7.3l0.1-0.4
									L8.9,6.6L8.9,6.6z M8,5.5c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,5.5,8,5.5z"></path></svg></button> <div id="Infobulle_Accueil" role="tooltip" class="tooltips_info"><div><p>Entrer le nom du formateur ou de l’entreprise.</p></div> <button aria-controls="Infobulle_Accueil" aria-label="Fermer information supplémentaire" class="button-info-fermer"><svg xmlns="http://www.w3.org/2000/svg" fill="#095797" viewBox="0 0 16 16" class="bi bi-x"><desc>Icône pour fermer la boite d'information supplémentaire</desc><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path></svg></button></div> <div aria-hidden="true" class="tooltip_arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16"><path d="M16 0l16 16H0z"></path></svg></div></aside>
                                    <input class="tx-solr-q js-solr-q tx-solr-suggest tx-solr-suggest-focus form-control" role="search" aria-label="Recherche par mots clés" autocomplete="off" id="recherche_par_mots_cles" type="text" v-model="rechercheMotsCles" @input="onClickRecherche"
/>

                <button id="bouton_reset_input" v-show="rechercheMotsCles.length > 0" @click="onClickResetMotsCles" type="button" aria-label="Bouton pour effacer le champ mots clés" class="btn_reset_input_inside"><span><svg xmlns="http://www.w3.org/2000/svg" fill="#095797" version="1.1" width="16" height="16" viewBox="0 0 40 40">
<path d="M21.414 21l17.293-17.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-17.293 17.293-17.293-17.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l17.293 17.293-17.293 17.293c-0.391 0.391-0.391 1.024 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l17.293-17.293 17.293 17.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414l-17.293-17.293z"/>
</svg></span></button> 
            </div>
        </div>
      
    </div>
</template>

<script>
    export default{
        name:"RechercheCond",
        components: {
    
        },
        emits: ['filtreRecherche'],
        props: {
    
        },
        data(){
            return{
                rechercheMotsCles:'',
            }
        }, 
        methods:{
            onClickRecherche(){
                let rechercheMotsCles=this.rechercheMotsCles;
                this.$emit('filtreRecherche',rechercheMotsCles);
                document.getElementById('bouton_reset_input').style.display="block";
            },
            onClickEnter(){
                this.onClickRecherche()
            },
            onClickResetMotsCles(){
                document.querySelector('#recherche_par_mots_cles').value = '';
                this.rechercheMotsCles="";
                this.onClickRecherche()
            }
        },
        computed: {
    
        }
    }
</script>